import { observable, action, makeObservable, reaction, computed } from 'mobx'

import { BlockModel } from '@client/components/Block/model'
import { defaultSettings } from './constants'
import { MIN_HEIGHT, MIN_WIDTH } from '@client/components/Block/constants'

export default class ConfirmButtonModel extends BlockModel {
  constructor(data = {}, editor) {
    super(data)

    makeObservable(this)

    this.editor = editor

    this.settings.set({
      ...{
        text: defaultSettings.text,
      },
      ...data.settings,
    })

    reaction(
      () => this.containerDimensions.width,
      (containerWidth) => {
        if (this.editor?.viewMode === 'mobile') return

        const shouldMaxWidth =
          +this.settings.values.width > containerWidth ||
          this.settings.values.fullWidth

        if (shouldMaxWidth && containerWidth >= MIN_WIDTH) {
          this.settings.set({
            width: containerWidth.toString(),
          })
        }
      }
    )
  }

  @observable containerDimensions = { width: 0, height: 0 }

  @action setContainerDimensions = ({ button_width, ...obj }) => {
    if (
      typeof obj.width !== 'undefined' &&
      this.containerDimensions.width !== obj.width &&
      obj.width >= MIN_WIDTH
    ) {
      this.containerDimensions.width = obj.width
    }
    if (
      typeof obj.height !== 'undefined' &&
      this.containerDimensions.height !== obj.height &&
      obj.height >= MIN_HEIGHT
    ) {
      this.containerDimensions.height = obj.height
    }
    if (
      this.editor?.viewMode !== 'mobile' &&
      obj.width >= MIN_WIDTH && (
        this.settings.values.width > obj.width ||
        (
          +button_width > obj.width &&
          this.settings.values.width !== obj.width &&
          !this.settings.values.width
        )
      )
    ) {
      this.settings.set({ width: obj.width })
    }
  }

  @action setText = (text) => {
    if (this.settings.values.text !== text) {
      this.settings.set({ text: text })
    }
  }

  @computed get allColors() {
    const s = this.settings.values
    const colors = [
      s.backgroundColor,
      s.borderColor,
      s.textColor,
    ]

    return Array.from(new Set(colors.filter(Boolean)))
  }
}

export const NULL = new ConfirmButtonModel()
